export enum PlayerRole {
  Player = 1,
  Viewer = 2
}
